import React from "react";
import {useParams} from "react-router";
import {css, Theme} from "@emotion/react";

import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {IRankingAnnualParams, IRankingParams} from "@pg-mono/rp-routes";

import {ISearchedRegion} from "../types/ISearchedRegion";

interface IProps {
    currentRegion: ISearchedRegion;
}

export const LocationRankingDescription = (props: IProps) => {
    const {currentRegion} = props;
    const params = useParams<IRankingParams & Partial<Pick<IRankingAnnualParams, "year">>>();

    if (params.year && params.year === "2022") {
        return null;
    }

    return (
        <section css={locationDescriptionHolder}>
            <div css={locationGeneratedText} dangerouslySetInnerHTML={{__html: currentRegion.region_description}} />
        </section>
    );
};

// Styles
const locationDescriptionHolder = (theme: Theme) => css`
    background-color: #fff;
    ${borderRadius()};
    ${p(3)};
    ${mb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(4)};
    }
`;

const locationGeneratedText = css`
    * {
        font-size: 1.575rem;
        line-height: 2.4rem;
    }
`;
